import { IconChevronLeft, IconX } from '@tabler/icons-react-native';
import { Button } from 'app/design/primitives/button';
import { createTheme as createDSTheme } from 'app/shopify';
import type { ScreenOptionsNavigationProp } from 'app/types/navigation';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

const theme = createDSTheme();

export function HeaderLeft({ navigation, canGoBack }: { navigation: ScreenOptionsNavigationProp; canGoBack: boolean }) {
  const handlePress = () => {
    navigation.goBack();
  };

  return (
    <Button onPress={handlePress}>
      {!canGoBack ? (
        <IconX strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
      ) : (
        <IconChevronLeft strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
      )}
    </Button>
  );
}
